import React from 'react';
import { XCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  const points = ['Buscás información técnica que nunca aplica exactamente a tu auto', 'Le pagás al mecánico sin saber si el precio es justo', 'Salís sin revisar nada porque no sabés qué revisar', 'No entendés qué significa ninguna luz del tablero', 'Te da miedo que te pasen por arriba en cualquier taller', 'El mismo ciclo de gastos imprevistos y sorpresas, todos los meses'];
  return <section className="py-24 relative overflow-hidden" aria-label="Problemas comunes de conductores" data-id="element-169">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-170">
        <FadeIn data-id="element-171">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-8" data-id="element-172">
            ¿Cuántos meses más vas a manejar{' '}
            <span className="text-red-500" data-id="element-173">
              sin saber qué está pasando con tu auto?
            </span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-174">
          <p className="text-lg md:text-xl text-gray-300 text-center mb-12 leading-relaxed" data-id="element-175">
            Dependés del auto para trabajar, moverte y cuidar a tu familia. Pero
            nadie te dijo que ibas a pasar los domingos buscando en YouTube,
            pagando lo que te dice el mecánico sin poder cuestionar nada, y
            manejando con luces del tablero encendidas que "seguramente no son
            nada".
            <br data-id="element-176" />
            <br data-id="element-177" />
            <strong className="text-white" data-id="element-178">
              No es falta de interés. Es falta de un sistema.
            </strong>
          </p>
        </FadeIn>

        <div className="bg-surface p-8 md:p-10 rounded-3xl border border-red-500/20 shadow-[0_0_30px_rgba(239,68,68,0.05)]" data-id="element-179">
          <ul className="space-y-6" data-id="element-180">
            {points.map((point, index) => <FadeIn key={index} delay={0.2 + index * 0.1} data-id="element-181">
                <li className="flex items-start gap-4" data-id="element-182">
                  <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-183" />
                  <span className="text-lg text-gray-300" data-id="element-184">{point}</span>
                </li>
              </FadeIn>)}
          </ul>
        </div>

        <FadeIn delay={0.8} data-id="element-185">
          <div className="mt-16 text-center" data-id="element-186">
            <p className="text-2xl md:text-3xl font-heading text-cyan" data-id="element-187">
              ¿Y si este fuera el último mes que manejás sin estar completamente
              blindado?
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}